import React, { useEffect, useRef, useState } from 'react'
import { BORDER_HEIGHT } from '../helpers/constansts';
import { differenceInMinutes } from 'date-fns';
import WhiteTooltip from './WhiteTooltip';
import moment from 'moment';
import { AppConstant } from '../../../../Assests/AppConstant';
import { IoMdInformationCircleOutline } from "react-icons/io";

function Break({
  data,
  minuteHeight,
  top,
  step,
  showScheduleModal,
  setShowScheduleModal,
  left,
  dayOfWeek,
  selectedDock,
  whMetaDocksList
}) {
  const [showTooltip, setShowTooltip] = useState(false);
  const infoRef = useRef(null);
  

  const isSegmentOperational = (segment) => {
    if (segment.dockId === "0000") {
      return false;
    }
    // Check break's operational days directly from segment
    return segment[dayOfWeek] === true;
  };
  
  const filteredSegments = data.segments
    ? data.segments.filter(el => {
        if (!isSegmentOperational(el)) {
          return false;
        }
        if (selectedDock && selectedDock.length && selectedDock[0].dockId !== "0000") {
          return el.dockId === selectedDock[0].dockId;
        }
        return true;
      })
    : [];

  let height = 0;
  if (filteredSegments.length > 0) {
    const maxDuration = Math.max(...filteredSegments.map(seg => differenceInMinutes(seg.end, seg.start)));
    height = maxDuration * minuteHeight;
  } else {
    height = differenceInMinutes(data.end, data.start) * minuteHeight;
  }

  if (filteredSegments.length === 0) {
    return null;
  }

  return (
    <div
      className="rs__event__item custom__event__ss rs___break pointer striped-block"
      style={{
        position: "absolute",
        height: height,
        top: `${top}px`,
        left: `${left}%`,
        width: `${100}%`,
      }}
      onClick={() => setShowScheduleModal(true)}
    >
      <div className="d-flex justify-content-end position-relative">
        <span
          className="break__typo"
          ref={infoRef}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <IoMdInformationCircleOutline />
        </span>

        <WhiteTooltip show={showTooltip} anchorRef={infoRef}>
          <div>
            <strong className="mb-1 d-block">Break Details</strong>

            <ul className="list-unstyled mb-0">
              {filteredSegments.map((el, i) => {
                // Parse UTC times and convert to local timezone (IST)
                const startTime = moment.utc(el.start).local().format(AppConstant.commonStrings.hh_mm_A_dateFormat);
                const endTime = moment.utc(el.end).local().format(AppConstant.commonStrings.hh_mm_A_dateFormat);
                return (
                <li
                  key={i}
                  className="d-flex align-items-center mb-1 break-tooltip-item"
                >
                  <div
                    className="code__legend"
                    style={{ backgroundColor: el.dockColor }}
                  />
                  <div>
                  <div className='fw-600'>
                    {`${el.dockName} - ${el.Description}`}
                  </div>
                  <div>
                    <i className="fa-regular fa-clock me-2"></i>
                    {`${startTime} - ${endTime}`}
                  </div>
                  </div>
                </li>
              );
              })}
            </ul>
          </div>
        </WhiteTooltip>

      </div>
    </div>
  );
}

export default Break;


